import { axiosInstance } from "./";

const getRoles = (params) => axiosInstance.get(`/admin_roles`, { params });

const getRole = ({ id }) => axiosInstance.get(`/admin_roles/${id}`);

const createRole = (data) => axiosInstance.post(`/admin_roles`, data);

const deleteRole = ({ id }) => axiosInstance.delete(`/admin_roles/${id}`);

const editRole = ({ role_id, permissions }) =>
  axiosInstance.patch(`/admin_roles/${role_id}/permissions/bulk_update`, {
    permissions,
  });

const updateStatusRole = ({ id }) =>
  axiosInstance.patch(`/admin_roles/${id}/update_status`);

const promoteRole = ({ id }) =>
  axiosInstance.patch(`/roles/${id}/promote_role_users_to_admin`);

const demoteRole = ({ id }) =>
  axiosInstance.patch(`/roles/${id}/demote_role_users_from_admin`);

const getSingleRole = ({ id }) => axiosInstance.get(`/admin_roles/${id}/`);

const updateSingleRole = ({ id, params }) =>
  axiosInstance.patch(`/admin_roles/${id}/`, params);

export {
  getRoles,
  getRole,
  updateStatusRole,
  createRole,
  deleteRole,
  editRole,
  promoteRole,
  demoteRole,
  getSingleRole,
  updateSingleRole,
};
